import { type WithTaskId } from '../model'
import { type WithOptionalScheme, withScheme } from './util'

export const toTasks = ({ includeScheme = false }: WithOptionalScheme = {}): string => {
  return withScheme('tasks/tasks', includeScheme)
}

export const toTask = ({ includeScheme = false, taskId }: WithOptionalScheme & WithTaskId): string => {
  return withScheme(`task/${taskId}`, includeScheme)
}
